module finadai.app.customers.detail {
  import ProxyRecord = models.http.responses.ProxyRecord;
  export var NAME = "finadai.app.customers.detail"
  function CustomerDetailController(customer: ng.IHttpPromiseCallbackArg<ProxyRecord<models.proxy.Customer>>, 
                                    creditInfo:  ng.IHttpPromiseCallbackArg<ProxyRecord<models.proxy.Credito>>, 
                                    negotiation:  ng.IHttpPromiseCallbackArg<ProxyRecord<models.proxy.Negociacion>>,
                                    customersService: services.CustomersService, whoIAm: models.User, $rootScope, $scope, notify,
                                    confirm, $mdDialog: ng.material.IDialogService, $state: ng.ui.IStateService, 
                                    negotiationsService: services.NegotiationsService, proxifier, $q: ng.IQService,
                                    authService: services.AuthService) {

    $scope.hasNegotiation = false;
    $scope.hasSelectedPlan = false;
    $scope.granters = [];
    $scope.customer = customer.data.Data;
    $scope.user_pdf = whoIAm.pdf;
    $scope.havePdf = whoIAm.pdf != "na";
    $scope.the_bank = 0;
    if ($scope.customer.NumCliente.startsWith("3")) {
      $scope.the_bank = 3;
    } else if ($scope.customer.NumCliente.startsWith("4")) {
      $scope.the_bank = 4;
    } else if ($scope.customer.NumCliente.startsWith("5")) {
      $scope.the_bank = 5;
    }

    $scope.is_hsbc = $scope.customer.NumCliente.startsWith("3");

    $scope.user_pdf_paid = whoIAm.pdf_paid;
    $scope.havePdfPaid = whoIAm.pdf_paid != "na";
    $scope.haveDueNegotiation = whoIAm.due_negotiation;

    $scope.activityData = {};
    $scope.selectedCredit = [];
    $scope.selectedGranting = '';
    $scope.customerCredits = angular.isArray(creditInfo.data.Data.Saldo) ? creditInfo.data.Data.Saldo : [creditInfo.data.Data.Saldo];
    $scope.customerNegotiation = negotiation.data.Data;
    $scope.hasNegotiation = angular.isDefined($scope.customerNegotiation.Encabezado);
    $scope.negotitationDetailed = [];
    if($scope.hasNegotiation && angular.isDefined($scope.customerNegotiation.Detalle.ConvenioDetalle)) {
        $scope.negotitationDetailed = angular.isArray($scope.customerNegotiation.Detalle.ConvenioDetalle) ? $scope.customerNegotiation.Detalle.ConvenioDetalle : [$scope.customerNegotiation.Detalle.ConvenioDetalle];
    }
    $scope.canCreateActivity = whoIAm.operations.indexOf('activities_store') >= 0;
    $rootScope.$broadcast('searchOveraly:close');
    $scope.loadingPaymentOptions = true;
    $scope.paymentOptions = [];
    $scope.hoy = new Date();
    $scope.principioMes = moment().startOf('month').toDate();
    $scope.terms = [
      { text: "Reconozco la existencia de mi(s) crédito(s) que se identifica(n) arriba en la Sección \"Información Original del Credito\"", accepted: false },
      { text: "Reconozco que a la Fecha Efectiva, mi saldo(s) es(son) el(los) que aparece arriba en la Sección \"Información Original del Credito\"", accepted: false },
      { text: `Acepto que (i) mi saldo total sea redocumentado y que, una vez redocumentado, quede como se indica arriba en la Sección "Condiciones de tu Nuevo Crédito"
, y (ii) los 
        demás términos de mi(s) crédito(s) permanecen sin cambio`, accepted: false },
      { text: "Reconozco que, derivado de dicha redocumentación, adeudo el Nuevo Saldo que aparece arriba en la Sección \"Condiciones de tu Nuevo Crédito\"", accepted: false },
      { text: "Acepto liquidar el Nuevo Saldo mediante el Pago y por el número de pagos que aparecen arriba en la Sección \"Condiciones de tu Nuevo Crédito\"", accepted: false },
      { text: `Reconozco y acepto que, si incumplo cualquier pago del crédito redocumentado, mi(s) crédito(s) revertiría(n) a los términos que aparecen
        en la Sección "Información Original del Credito" anterior y los pagos que haya yo realizado se abonarían a dicho(s) crédito(s) de la Sección "Información Original del Credito", en los términos del Contrato
        de Crédito Original`, accepted: false }
    ]
    customersService.proxyPaymentOptions({pending_amount: models.proxy.getSaldoTotal(creditInfo.data.Data)}).then(response => {
      $scope.loadingPaymentOptions = false;
      $scope.paymentOptions = response.data.Data;
      $scope.paymentOptions = [];
    }).catch(error => {
      $scope.loadingPaymentOptions = false;
    });

    /**
     * TODO: can pay for Pagar en Banco depends on NumCliente validation.
     * */
    $scope.paymentPlans = [
      {
        title: "Pagar en Oxxo",
        description: "Oxxo Pay es un servicio ofrecido por Femsa",
        image: "/assets/images/oxxo-pay-logo-blanco.svg",
        alt: "Oxxo Pay Logo",
        canPay: () => true,
        is_oxxo_pay: 1
      },
      {
        title: "Pagar en Banco",
        description: "Es un Banco",
        image: "/assets/images/logo-spei.png",
        alt: "Banco Logo",
        canPay: () => true,
        is_oxxo_pay: 0
      }
    ];
    $scope.canSubmit = () => $scope.terms.filter(x => !x.accepted).length == 0
    $scope.selectedPaymentType = null;
    $scope.selectedPlan = null;
    $scope.selectPaymentType = (paymentType: models.proxy.PaymentType) => {
      setTimeout(() => {
        jQuery('html, body').animate({scrollTop: jQuery("#step2").offset().top-70}, 500);
      }, 0);
      paymentType.AmountNumber = parseFloat(paymentType.Amount);
      $scope.selectedPaymentType = angular.copy(paymentType);
    }
    $scope.selectPlan = (paymentPlan) => {
      setTimeout(() => {
        jQuery('html, body').animate({scrollTop: jQuery("#step3").offset().top-90}, 500);
      }, 0);
      $scope.selectedPlan = angular.copy(paymentPlan);
      $scope.hasSelectedPlan = true;
    }
    $scope.refreshPage = () => {
        location.reload();
    }
    $scope.cancelPlan = ev => {
      // const confirm = $mdDialog.confirm()
      //     .title('¿Qué quieres hacer?')
      //     .textContent('')
      //     .targetEvent(ev)
      //     .ok('Cambiar las condiciones de mi nuevo credito (Cuanto, Como y/o Donde Pagar).')
      //     .cancel('Pensarlo Mejor.');
      //
      // $mdDialog.show(confirm).then(function() {
      //   location.reload();
      // }, function() {
      //     authService.logout().then(function (response) { $state.go('login'); });
      // });

        $mdDialog.show({
            templateUrl: 'app/customers/detail/formQuestionNegotiation.tpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            controller: function ($scope: any) {
              $scope.logout = () => {
                authService.logout().then(function (response) { $state.go('login'); }).then( () => {$mdDialog.hide();}, () => {$mdDialog.hide();});

              }
              $scope.refreshPage = () => {
                location.reload();
              }
            },
            controllerAs: 'ctrl',
            clickOutsideToClose:true,
            escapeToClose: true,
            fullscreen: false
        })
    }
    $scope.refreshPage = ev => {
        location.reload();
    }
    $scope.modificarInfoDialog = ev => {
      const data = angular.copy($scope.customer);
      data.FechaNacimiento = moment(data.FechaNacimiento).toDate();
      $mdDialog.show({
        controller: ($scope, $mdDialog) => {
          $scope.formData = data;
          $scope.submit = (form) => {
            if(form.$valid) {
              $scope.saving = true;
              delete $scope.formData.ReferenciaHSBC;
              $scope.formData.NumCliente;
              $scope.formData.rfc = $scope.formData.RFC;
              customersService.proxySaveCustomer($scope.formData).then(response => {
                $scope.saving = false;
                $mdDialog.hide(response.data.Data);
              }).catch(error => {
                $scope.saving = false;
                console.log(error);
                $mdDialog.hide();
              });
            }
          };
          $scope.cancel = function() {
            $mdDialog.hide();
          }
        },
        templateUrl: 'app/customers/detail/formPersonalInfo.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        escapeToClose: true,
        fullscreen: false
      }).then(customer => {
        if (customer != null) {
           $scope.customer = customer;
        }
      }, function() {
        $scope.status = 'You cancelled the dialog.';
      });
    }
    $scope.generateNegotiation = () => {
      // customersService.proxyGetNegotiation({rfc: whoIAm.rfc})
      const promise = customersService.proxySaveNegotiation({
        customer_number: whoIAm.customer_number,
        rfc: whoIAm.rfc,
        payment_type_id: $scope.selectedPaymentType.Id,
        payment_amount: $scope.selectedPaymentType.Amount,
        user_id: whoIAm.id,
        phone: whoIAm.phone,
        is_oxxo_pay: $scope.selectedPlan.is_oxxo_pay
      });
      $scope.loadingGeneratingNegotiation = true
      promise.then(response => {
        $scope.generatedNegotiationResponse = response.data.Data.Encabezado;
        $scope.pdf = response.data.Data.Encabezado.PDF;
        $scope.loadingGeneratingNegotiation = false
      }).catch(error => {
        $scope.loadingGeneratingNegotiation = false
      })
    }

    $scope.changeStatusCredit = (credit) => {
      if(credit.credit_status_id != credit.new_credit_status_id) {
        customersService.changeStatusCredit({credit_id: credit.id, credit_status_id: credit.new_credit_status_id}).then(response => {
          notify('Estado de Credito Actualizado.');
        })
      }
    }

    $scope.getFileIcon = (file_path) => {
      if(file_path.endsWith('.png') || file_path.endsWith('.jpeg') || file_path.endsWith('.jpg') || file_path.endsWith('.gif'))
        return 'fa-picture-o';
      if(file_path.endsWith('.xls') || file_path.endsWith('.xlsx'))
        return 'fa-file-excel-o';
      if(file_path.endsWith('.doc') || file_path.endsWith('.docx'))
        return 'fa-file-word-o';
      if(file_path.endsWith('.pdf'))
        return 'fa-file-pdf-o';
      return 'fa-file-o';
    }
    $scope.getFileUrl = (file_path) => {
      return proxifier(false) + file_path;
    }
    $scope.deleteFile = (file: models.File, index) => {
      customersService.deleteFile(file.id, $scope.customer.id).then(response => {
        if(response.status == 200){
          $scope.customer.media.splice(index, 1);
        }
      })
    }
    $scope.sendInviteForm = (ev, negotiation) => {
      var formData = angular.isUndefined(negotiation) ? { customer_id: $scope.customer.id } : { negotiation_id: negotiation.id };
      $mdDialog.show({
        controller: (config, $mdDialog, $scope, customersService: services.CustomersService) => {
          $scope.config = config;
          $scope.formData = config.data;
          $scope.cancel = () => { $mdDialog.cancel() };
          $scope.submit = (form) => {
            if(form.$valid){
              var promise = angular.isUndefined($scope.formData.negotiation_id) ?  customersService.sendInvite($scope.formData) : negotiationsService.send($scope.formData)
              promise.then(response => {
                $mdDialog.hide(response);
              });
            }
          }
        },
        templateUrl: 'app/customers/detail/formEmail.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: { config: {entity: { add: 'Enviar email', save: 'Enviar' }, data: formData}}
      }).then(response => {
        notify(negotiation == null ? 'Invitación enviada' : 'Negociación enviada');
      });
    }
    $scope.getGranters = () => {
      if($scope.granters.length == 0){
        $scope.granters = [];
        $scope.customer.credits.map(x => x.granter).forEach(el => {
          if($scope.granters.map(x => x.id).indexOf(el.id) < 0){
            $scope.granters.push(el)
          }
        });
      }
      return $scope.granters;
    }
    $scope.form = (entity, data, ev) => {
      $mdDialog.show({
        controller: FormEntityController,
        templateUrl: entity.formUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: { config: {entity: entity, data: data, customerId: $scope.customer.id}}
      }).then(response => {
        notify('Registro guardado');
      });
    }
    $scope.formEditCredit = (credit: models.Credit, index, ev) => {
      $mdDialog.show({
        controller: FormCreditController,
        templateUrl: 'app/customers/detail/formCredit.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: { config: { data: {credit_id: credit.id, pending_amount: credit.pending_amount, last_payment: credit.last_payment._date, amount_payable: credit.amount_payable} } }
      }).then(response => {
        notify('Crédito actualizado');
        $scope.customer.credits[index] = response;
      });
    }
    $scope.formCancelNegotiation = (negotiation: models.Negotiation, index, ev) => {
        $mdDialog.show({
            controller: FormNegotiationController,
            templateUrl: 'app/customers/detail/formCancelNegotiation.tpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: { config: { data: {negotiation_id: negotiation.id} } }
        }).then(response => {
            notify('Negociación cancelada');
        });
    }
    $scope.formEditCustomerName = (customer: models.Customer, ev) => {
      $mdDialog.show({
        controller: FormCustomerNameController,
        templateUrl: 'app/customers/detail/formCustomerName.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: { config: { data: {customer_id: customer.id, name: customer.name, last_name: customer.last_name} } }
      }).then(response => {
        notify('Cliente actualizado');
        $scope.customer.name = response.name;
        $scope.customer.last_name = response.last_name;
      });
    }
  }
  function FormEntityController(config, $mdDialog, $scope, customersService: services.CustomersService){
    $scope.config = config;
    $scope.formData = angular.copy($scope.config.data);
    if(config.entity.type == "references" && angular.isDefined($scope.formData.relationship_id)){
      $scope.formData.relationship_id = $scope.formData.relationship_id.toString();
    }
    $scope.cancel = () => { $mdDialog.cancel() };
    $scope.submit = (form) => {
      if(form.$valid){
        customersService.save($scope.formData, $scope.config.data.id, $scope.config.entity.type, $scope.config.customerId).then(response => {
          $mdDialog.hide(response);
        });
      }
    }
  }
  function FormCreditController(config, $mdDialog, $scope, negotiationsService: services.NegotiationsService){
    $scope.formData = config.data;
    $scope.cancel = () => { $mdDialog.cancel() };
    $scope.submit = (form) => {
      if(form.$valid){
        negotiationsService.saveCredit(config.data.credit_id, $scope.formData).then(response => {
          $mdDialog.hide(response.data);
        });
      }
    }
  }
    function FormNegotiationController(config, $mdDialog, $scope, negotiationsService: services.NegotiationsService){
        $scope.formData = config.data;
        $scope.cancel = () => { $mdDialog.cancel() };
        $scope.submit = (form) => {
            if(form.$valid){
                negotiationsService.cancelNegotiation($scope.formData).then(response => {
                    $mdDialog.hide(response.data);
                });
            }
        }
    }
  function FormCustomerNameController(config, $mdDialog, $scope, customersService: services.CustomersService){
    $scope.formData = config.data;
    $scope.cancel = () => { $mdDialog.cancel() };
    $scope.submit = (form) => {
      if(form.$valid){
        customersService.updateName(config.data.customer_id, $scope.formData).then(response => {
          $mdDialog.hide(response.data);
        });
      }
    }
  }
  export function run() {
    var detail = angular.module(NAME, [])
    detail.controller("CustomerDetailController", CustomerDetailController)
  }
}
finadai.app.customers.detail.run();